import { render, staticRenderFns } from "./confirmBindDialog.vue?vue&type=template&id=20d3b51a&scoped=true&"
import script from "./confirmBindDialog.vue?vue&type=script&lang=js&"
export * from "./confirmBindDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d3b51a",
  null
  
)

export default component.exports